var exports = {
  "Ze": "AddFriendView.module__friendRequestContainer___MkNOUn",
  "Nr": "AddFriendView.module__card___MkNOUn",
  "Og": "AddFriendView.module__heroIcon___MkNOUn",
  "DD": "AddFriendView.module__title___MkNOUn",
  "VA": "AddFriendView.module__subtitle___MkNOUn",
  "KJ": "AddFriendView.module__formContainer___MkNOUn",
};

module.exports = exports;
